import { ConfigMurucaAdvancedSearchLayout } from '@net7/boilerplate-muruca';
import { MOTIVOS } from '../motivos';

export default {
  title: 'Búsqueda avanzada',
  resultsUrl: { it: '/risultati' },
  hasDynamicOptions: true,
  formConfig: {
    submitButton: {
      label: 'advancedsearch#submit',
    },
    resetButton: {
      label: 'advancedsearch#reset',
    },
    groups: [
      {
        id: 'group-message',
        sections: ['section-message'],
        classes: 'form-group-message',
        options: {
          isOpen: true,
          showHeader: false,
        },
      },
      {
        id: 'group-bibliograficos',
        sections: [
          'section-title',
          'section-authorship',
          'section-authorship-other',
          'section-parts',
          'section-manuscrito-consta',
          'section-otras-ediciones',
          'section-collections',
          'section-ediciones-singulares',
          'section-refundiciones-consta',
          'section-bibliografia-url',
        ],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#bibliograficos',
          isOpen: false,
          showHeader: true,
        },
      },
      {
        id: 'group-fecha',
        sections: [
          'section-fecha',
          'section-computo',
          'section-notas',
        ],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#fecha',
          isOpen: false,
          showHeader: true,
        },
      },
      {
        id: 'group-personajes',
        sections: [
          'section-espacio-dramaticos',
          'section-personajes-computables',
          'section-personajes-no-computables',
          'section-universo-social',
          'section-ambientacion-cronologica',
          'section-duracion-obra',
          'section-duracion-acto-I',
          'section-duracion-entreacto-I-II',
          'section-duracion-acto-II',
          'section-duracion-entreacto-II-III',
          'section-duracion-acto-III',
        ],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#personajes',
          isOpen: false,
          showHeader: true,
        },
      },
      {
        id: 'group-genero',
        sections: [
          'section-propuesta-generica',
          'section-propuesta-secundaria',
          'section-motivos',
          'section-sinopsis',
        ],
        classes: 'form-group-1',
        options: {
          label: 'advancedsearch#genero',
          isOpen: false,
          showHeader: true,
        },
      },
    ],
    sections: [
      {
        id: 'section-message',
        description: 'advancedsearch#message',
        inputs: [],
      },

      // DATOS BIBLIOGRAFICOS
      {
        id: 'section-title',
        title: 'advancedsearch#label_titulo',
        advancedSection: true,
        inputs: [
          {
            id: 'query-titulo',
            type: 'text',
            class: 'classe-sing',
            classes: 'classe-plur',
            data: {
              id: 'query-titulo',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ]
      },
      {
        id: 'section-authorship',
        title: 'advancedsearch#label_autoria',
        advancedSection: true,
        inputs: [
          {
            id: 'query-authorship',
            type: 'select',
            data: {
              id: 'query-authorship',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Fiable', value: 'Fiable' },
                { label: 'Dudosa', value: 'Dudosa' },
                { label: 'Colaborada', value: 'Colaborada' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-authorship-other',
        title: 'advancedsearch#label_otros-autores',
        info: 'advancedsearch#info_otros-autores',
        advancedSection: true,
        inputs: [
          {
            id: 'query-authorship-other',
            type: 'text',
            data: {
              id: 'query-authorship_other',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-parts',
        title: 'advancedsearch#label_parte',
        info: 'advancedsearch#info_parte',
        advancedSection: true,
        inputs: [
          {
            id: 'query-parts',
            type: 'select',
            data: {
              id: 'query-parts',
              label: '',
              options: [
                { label: '---', value:''},
                { label: 'Primera Parte', value: 'Primera Parte' },
                { label: 'Segunda Parte', value: 'Segunda Parte' },
                { label: 'Tercera Parte', value: 'Tercera Parte' },
                { label: 'Cuarta Parte', value: 'Cuarta Parte' },
                { label: 'Quinta Parte', value: 'Quinta Parte' },
                { label: 'Verdadera Quinta Parte', value: 'Verdadera Quinta Parte' },
                { label: 'Sexta Parte', value: 'Sexta Parte' },
                { label: 'Séptima Parte', value: 'Séptima Parte' },
                { label: 'Octava Parte', value: 'Octava Parte' },
                { label: 'Novena Parte', value: 'Novena Parte' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-manuscrito-consta',
        title: 'advancedsearch#label_manuscrito',
        info: 'advancedsearch#info_manuscrito',
        advancedSection: true,
        inputs: [
          {
            id: 'query-manuscrito-consta',
            type: 'select',
            data: {
              id: 'query-manuscrito-consta',
              label: '',
              options: [
                { label: 'Consta / No consta', value: '' },
                { label: 'Consta', value: 'true' },
                { label: 'No consta', value: 'false' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-manuscrito-tipo',
            type: 'select',
            options: { classes: 'flex-select' },
            data: {
              id: 'query-manuscrito-tipo',
              label: 'advancedsearch#label_manuscrito-tipo',
              options: [
                { label: '---', value: '' },
                { label: 'Copia', value: 'copia' },
                { label: 'Autógrafo', value: 'autógrafo' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-biblioteca',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-biblioteca',
              label: 'advancedsearch#label_biblioteca',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-biblioteca',
        advancedSection: true,
        inputs: [
          {
            id: 'query-biblioteca',
            type: 'text',
            data: {
              id: 'query-biblioteca',
              label: 'advancedsearch#label_biblioteca',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-otras-ediciones',
        title: 'advancedsearch#label_otras-ediciones',
        info: 'advancedsearch#info_otras-ediciones',
        advancedSection: true,
        inputs: [
          {
            id: 'query-otras-ediciones-colecciones-consta',
            type: 'select',
            options: { classes: 'flex-select' },
            data: {
              id: 'query-otras-ediciones-colecciones-consta',
              label: 'advancedsearch#label_otras-ediciones-colecciones',
              options: [
                { label: 'Consta / No consta', value: '' },
                { label: 'Consta', value: 'true' },
                { label: 'No consta', value: 'false' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-otras-ediciones-suelta-consta',
            type: 'select',
            options: { classes: 'flex-select' },
            data: {
              id: 'query-otras-ediciones-suelta-consta',
              label: 'advancedsearch#label_otras-ediciones-suelta',
              options: [
                { label: 'Consta / No consta', value: '' },
                { label: 'Consta', value: 'true' },
                { label: 'No consta', value: 'false' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-otras-ediciones',
            type: 'text',
            data: {
              id: 'query-otras-ediciones',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-collections',
        title: 'advancedsearch#label_colecciones-modernas',
        advancedSection: true,
        inputs: [
          {
            id: 'query-collections',
            type: 'select',
            data: {
              id: 'query-collections',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Aguilar', value: 'Aguilar' },
                { label: 'Biblioteca Castro', value: 'Biblioteca Castro' },
                { label: 'Boosey', value: 'Boosey' },
                { label: 'Edición cubana', value: 'Edición cubana' },
                { label: 'Hartzenbusch', value: 'Hartzenbusch' },
                { label: 'Keil', value: 'Keil' },
                { label: 'Senior', value: 'Senior' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-ediciones-singulares',
        title: 'advancedsearch#label_ediciones-singulares',
        advancedSection: true,
        inputs: [
          {
            id: 'query-ediciones-singulares-consta',
            type: 'select',
            data: {
              id: 'query-ediciones-singulares-consta',
              label: '',
              options: [
                { label: 'Consta / No consta', value: '' },
                { label: 'Consta', value: 'true' },
                { label: 'No consta', value: 'false' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-ediciones-singulares',
            type: 'text',
            data: {
              id: 'query-ediciones-singulares',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-refundiciones-consta',
        title: 'advancedsearch#label_refundiciones-consta',
        advancedSection: true,
        inputs: [
          {
            id: 'query-refundiciones-consta',
            type: 'select',
            data: {
              id: 'query-refundiciones-consta',
              label: '',
              options: [
                { label: 'Consta / No consta', value: '' },
                { label: 'Consta', value: 'true' },
                { label: 'No consta', value: 'false' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-language',
            type: 'select',
            options: { classes: 'flex-select' },
            data: {
              id: 'query-language',
              label: 'advancedsearch#label_refundiciones-lengua',
              options: [
                { label: '---', value: '' },
                { label: 'Alemán', value: 'Alemán' },
                { label: 'Checo', value: 'Checo' },
                { label: 'Danés', value: 'Danés' },
                { label: 'Español', value: 'Español' },
                { label: 'Francés', value: 'Francés' },
                { label: 'Holandés', value: 'Holandés' },
                { label: 'Húngaro', value: 'Húngaro' },
                { label: 'Inglés', value: 'Inglés' },
                { label: 'Italiano', value: 'Italiano' },
                { label: 'Polaco', value: 'Polaco' },
                { label: 'Ruso', value: 'Ruso' },
                { label: 'Sueco', value: 'Sueco' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-refundiciones-autor',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-refundiciones-autor',
              label: 'advancedsearch#label_refundiciones-autor',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      
      {
        id: 'section-bibliografia-url',
        title: 'advancedsearch#label_bibliografia-url',
        info: 'advancedsearch#info_bibliografia-url',
        advancedSection: true,
        inputs: [
          {
            id: 'query-bibliografia-url',
            type: 'select',
            data: {
              id: 'query-bibliografia-url',
              label: '',
              options: [
                { label: 'URL / No URL', value: '' },
                { label: 'URL', value: 'http*' },
                { label: 'No URL',  value: '!*' },
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-bibliografia-autor',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-bibliografia-autor',
              label: 'advancedsearch#label_bibliografia-autor',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-bibliografia-notas',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-bibliografia-notas',
              label: 'advancedsearch#label_bibliografia-notas',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-bibliografia-titulo',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-bibliografia-titulo',
              label: 'advancedsearch#label_bibliografia-titulo',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },

      // FECHA, COMPUTO DE VERSOS Y ESTROFAS
      {
        id: 'section-fecha',
        title: 'advancedsearch#label_fecha',
        advancedSection: true,
        info: 'advancedsearch#info_fecha',
        inputs: [
          {
            id: 'query-fecha',
            type: 'text',
            data: {
              id: 'query-fecha',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-computo',
        title: 'advancedsearch#label_computo',
        advancedSection: true,
        info: 'advancedsearch#info_computo',
        inputs: [
          {
            id: 'metric_metric',
            type: 'select',
            data: {
              id: 'metric_metric',
              label: '',
              options: [
              ]
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-notas',
        title: 'advancedsearch#label_notas',
        info: 'advancedsearch#info_notas',
        advancedSection: true,
        inputs: [
          {
            id: 'query-notas',
            type: 'text',
            data: {
              id: 'query-note',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },

      // PERSONAJES, ESPACIO Y TIEMPO
      {
        id: 'section-espacio-dramaticos',
        title: 'advancedsearch#label_espacio-dramaticos',
        info: 'advancedsearch#info_espacio-dramaticos',
        advancedSection: true,
        inputs: [
          {
            id: 'query-espacio-dramaticos',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-espacio-dramaticos',
              label: 'advancedsearch#label_espacio-dramaticos',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
          {
            id: 'query-espacio-dramaticos-toponimos',
            type: 'text',
            options: { classes: 'title-text' },
            data: {
              id: 'query-espacio-dramaticos-toponimos',
              label: 'advancedsearch#label_espacio-dramaticos-toponimos',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-personajes-computables',
        title: 'advancedsearch#label_personajes-computables',
        advancedSection: true,
        inputs: [
          {
            id: 'query-personajes-computables',
            type: 'text',
            data: {
              id: 'query-personajes-computables',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-personajes-no-computables',
        title: 'advancedsearch#label_personajes-no-computables',
        advancedSection: true,
        inputs: [
          {
            id: 'work_character_not_computable',
            type: 'select',
            data: {
              id: 'work_character_not_computable',
              label: '',
              options: []
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-universo-social',
        title: 'advancedsearch#label_universo-social',
        advancedSection: true,
        inputs: [
          {
            id: 'work_social_universe',
            type: 'select',
            data: {
              id: 'work_social_universe',
              label: '',
              options: []
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-ambientacion-cronologica',
        title: 'advancedsearch#label_ambientacion-cronologica',
        advancedSection: true,
        inputs: [
          {
            id: 'chrono_set_period',
            type: 'select',
            data: {
              id: 'chrono_set_period',
              label: '',
              options: []
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-duracion-obra',
        title: 'advancedsearch#label_duracion-obra',
        advancedSection: true,
        inputs: [
          {
            id: 'query-durationWork',
            type: 'select',
            options: { classes: 'mr-duration-full' },
            data: {
              id: 'query-durationWork',
              label: '',
              options: [
                 { label: '---', value: '' },
                { label: 'Temporalidad alegórica o mítica', value: 'Temporalidad alegórica o mítica' },
                { label: 'Horas', value: 'Horas' },
                { label: 'Días', value: 'Días' },
                { label: 'Semanas', value: 'Semanas' },
                { label: 'Meses', value: 'Meses' },
                { label: 'Años', value: 'Años' },
                { label: 'Tiempo imprecisable', value: 'Tiempo imprecisable' },
              ]
            },
            state: { value: '', disabled: false, hidden: false },
          },
          {
            id: 'query-durationWork-operator',
            type: 'select',
            options: { classes: 'flex-select mr-duration-row mr-duration-row--operator' },
            data: {
              id: 'query-durationWork-operator',
              label: 'advancedsearch#label_duracion-comparacion',
              options: [
                { label: '---', value: '' },
                { label: 'Igual a', value: '=' },
                { label: 'Mayor o igual a', value: '>=' },
                { label: 'Menor o igual a', value: '<=' },
                // { label: 'Entre', value: '><' },
              ],
            },
            state: { value: '', disabled: false, hidden: false },
          },
          {
            id: 'query-durationWork-value',
            type: 'text',
            options: { classes: 'mr-duration-row mr-duration-row--value' },
            data: {
              id: 'query-durationWork-value',
              label: 'empty-label', // fake label leave as it is
              placeholder: '',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: { value: '', disabled: false, hidden: false },
          },
          {
            id: 'query-durationWork-unit',
            type: 'select',
            options: { classes: 'flex-select mr-duration-row mr-duration-row--unit' },
            data: {
              id: 'query-durationWork-unit',
              label: 'empty-label', // fake label leave as it is
              options: [
                { label: '---', value: '' },
                { label: 'hora/s', value: 'Horas' },
                { label: 'día/s', value: 'Días' },
                { label: 'semana/s', value: 'Semanas' },
                { label: 'mes/es', value: 'Meses' },
                { label: 'año/s', value: 'Años' },
              ],
            },
            state: { value: '', disabled: false, hidden: false },
          },
          {
            id: 'query-durationWork-intervalo-value-start',
            type: 'text',
            options: { classes: 'title-text mr-duration-row mr-duration-row--operator' },
            data: {
              id: 'query-durationWork-intervalo-value-start',
              label: 'advancedsearch#label_duracion-intervalo',
              placeholder: '',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: { value: '', disabled: false, hidden: false },
          },
          {
            id: 'query-durationWork-intervalo-value-end',
            type: 'text',
            options: { classes: 'mr-duration-row mr-duration-row--value' },
            data: {
              id: 'query-durationWork-intervalo-value-end',
              label: 'empty-label', // fake label leave as it is
              placeholder: '',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: { value: '', disabled: false, hidden: false },
          },
          {
            id: 'query-durationWork-intervalo-unit',
            type: 'select',
            options: { classes: 'flex-select mr-duration-row mr-duration-row--unit' },
            data: {
              id: 'query-durationWork-intervalo-unit',
              label: 'empty-label', // fake label leave as it is
              options: [
                { label: '---', value: '' },
                { label: 'hora/s', value: 'Horas' },
                { label: 'día/s', value: 'Días' },
                { label: 'semana/s', value: 'Semanas' },
                { label: 'mes/es', value: 'Meses' },
                { label: 'año/s', value: 'Años' },
              ],
            },
            state: { value: '', disabled: false, hidden: false },
          },
        ],
      },
      
      
      
      
      
      {
        id: 'section-duracion-acto-I',
        title: 'advancedsearch#label_duracion-acto-I',
        advancedSection: true,
        inputs: [
          {
            id: 'query-durationFirstActPeriod',
            type: 'select',
            data: {
              id: 'query-durationFirstActPeriod',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Temporalidad alegórica o mítica', value: 'Temporalidad alegórica o mítica' },
                { label: 'Horas', value: 'Horas' },
                { label: 'Días', value: 'Días' },
                { label: 'Semanas', value: 'Semanas' },
                { label: 'Meses', value: 'Meses' },
                { label: 'Años', value: 'Años' },
                { label: 'Tiempo imprecisable', value: 'Tiempo imprecisable' },
              ]
            },
            state: { value: '', disabled: false, hidden: false },
          },
        ],
      },
      {
        id: 'section-duracion-entreacto-I-II',
        title: 'advancedsearch#label_duracion-entreacto-I-II',
        advancedSection: true,
        inputs: [
          {
            id: 'query-durationFirstSecondPeriod',
            type: 'select',
            data: {
              id: 'query-durationFirstSecondPeriod',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Temporalidad alegórica o mítica', value: 'Temporalidad alegórica o mítica' },
                { label: 'Horas', value: 'Horas' },
                { label: 'Días', value: 'Días' },
                { label: 'Semanas', value: 'Semanas' },
                { label: 'Meses', value: 'Meses' },
                { label: 'Años', value: 'Años' },
                { label: 'Tiempo imprecisable', value: 'Tiempo imprecisable' },
              ]
            },
            state: { value: '', disabled: false, hidden: false },
          },
        ],
      },
      {
        id: 'section-duracion-acto-II',
        title: 'advancedsearch#label_duracion-acto-II',
        advancedSection: true,
        inputs: [
          {
            id: 'query-durationSecondActPeriod',
            type: 'select',
            data: {
              id: 'query-durationSecondActPeriod',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Temporalidad alegórica o mítica', value: 'Temporalidad alegórica o mítica' },
                { label: 'Horas', value: 'Horas' },
                { label: 'Días', value: 'Días' },
                { label: 'Semanas', value: 'Semanas' },
                { label: 'Meses', value: 'Meses' },
                { label: 'Años', value: 'Años' },
                { label: 'Tiempo imprecisable', value: 'Tiempo imprecisable' },
              ]
            },
            state: { value: '', disabled: false, hidden: false },
          },
        ],
      },
      {
        id: 'section-duracion-entreacto-II-III',
        title: 'advancedsearch#label_duracion-entreacto-II-III',
        advancedSection: true,
        inputs: [
          {
            id: 'query-durationSecondThirdPeriod',
            type: 'select',
            data: {
              id: 'query-durationSecondThirdPeriod',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Temporalidad alegórica o mítica', value: 'Temporalidad alegórica o mítica' },
                { label: 'Horas', value: 'Horas' },
                { label: 'Días', value: 'Días' },
                { label: 'Semanas', value: 'Semanas' },
                { label: 'Meses', value: 'Meses' },
                { label: 'Años', value: 'Años' },
                { label: 'Tiempo imprecisable', value: 'Tiempo imprecisable' },
              ]
            },
            state: { value: '', disabled: false, hidden: false },
          },
        ],
      },
      {
        id: 'section-duracion-acto-III',
        title: 'advancedsearch#label_duracion-acto-III',
        advancedSection: true,
        inputs: [
          {
            id: 'query-durationThirdActPeriod',
            type: 'select',
            data: {
              id: 'query-durationThirdActPeriod',
              label: '',
              options: [
                { label: '---', value: '' },
                { label: 'Temporalidad alegórica o mítica', value: 'Temporalidad alegórica o mítica' },
                { label: 'Horas', value: 'Horas' },
                { label: 'Días', value: 'Días' },
                { label: 'Semanas', value: 'Semanas' },
                { label: 'Meses', value: 'Meses' },
                { label: 'Años', value: 'Años' },
                { label: 'Tiempo imprecisable', value: 'Tiempo imprecisable' },
              ]
            },
            state: { value: '', disabled: false, hidden: false },
          },
        ],
      },

      // GENERO Y SINOPSIS
      {
        id: 'section-propuesta-generica',
        title: 'advancedsearch#label_propuesta-generica',
        info: 'advancedsearch#info_propuesta-generica',
        advancedSection: true,
        inputs: [
          {
            id: 'work_primary_proposal',
            type: 'select',
            data: {
              id: 'work_primary_proposal',
              label: '',
              options: []
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-propuesta-secundaria',
        title: 'advancedsearch#label_propuesta-secundaria',
        advancedSection: true,
        inputs: [
          {
            id: 'work_secondary_proposal',
            type: 'select',
            data: {
              id: 'work_secondary_proposal',
              label: '',
              options: []
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-motivos',
        title: 'advancedsearch#label_motivos',
        info: 'advancedsearch#info_motivos',
        advancedSection: true,
        inputs: [
          {
            id: 'query-motivos',
            type: 'typeahead',
            data: {
              id: 'query-motivos',
              label: '',
              placeholder: '',
              options: MOTIVOS,
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
      {
        id: 'section-sinopsis',
        title: 'advancedsearch#label_sinopsis',
        info: 'advancedsearch#info_sinopsis',
        advancedSection: true,
        inputs: [
          {
            id: 'query-sinopsis',
            type: 'text',
            data: {
              id: 'query-sinopsis',
              label: '',
              placeholder: '',
              icon: 'n7-icon-search',
              inputPayload: 'search-input',
              enterPayload: 'search-enter',
              iconPayload: 'search-icon',
            },
            state: {
              value: '',
              disabled: false,
              hidden: false,
            },
          },
        ],
      },
    ],
  },
} as ConfigMurucaAdvancedSearchLayout;
